module.exports = __webpack_public_path__ + "img/main.5fc88afa.png";